import { IConsumable, IConsumableExpiry } from '../interfaces/IConsumable';
export interface IInviteCredit {
  remainingLimit: number;
  dailyLimit: number;
  remainingCredits: number;
}

export default class Consumable {
  consumableID: string;
  description: string;
  groupName: string;
  imageURL: string;
  name: string;
  price: number;
  type: string;
  data: string;
  diamonds: number;
  category: string;
  level: number;
  isPopular: boolean;
  subName: string;

  constructor() {
    this.consumableID = '';
    this.description = '';
    this.groupName = '';
    this.imageURL = '';
    this.name = '';
    this.price = 0;
    this.type = '';
    this.data = '';
    this.diamonds = 0;
    this.category = '';
    this.level = 1;
    this.isPopular = false;
    this.subName = '';
  }

  static mappingConsumableProduct(_g: any): IConsumable {
    const g = new Consumable();
    if (_g) {
      g.consumableID = _g.ConsumableID;
      g.description = _g.Description;
      g.groupName = _g.GroupName;
      g.imageURL = _g.ImageURL || 'https://ak.picdn.net/shutterstock/videos/1082827489/thumb/9.jpg?ip=x480';
      g.name = _g.Name;
      g.price = _g.Price || 0;
      g.type = _g.Type;
      g.data = _g.Data || 'https://assets3.lottiefiles.com/packages/lf20_XZ3pkn.json';
      g.diamonds = _g.Diamonds || 0;
      g.category = _g.Category || '';
      g.level = _g.Level || 1;
      g.isPopular = _g.IsPopular || false;
      g.subName = _g.SubName || '';
    }
    return g;
  }

  static mappingConsumableProducts(_a: any[]): IConsumable[] {
    return _a?.map(g => Consumable.mappingConsumableProduct(g)) || [];
  }

  static mappingConsumablePurchaseResponse(data: any): IConsumableExpiry {
    let d = {
      remainingCredits: data.RemainingCredits,
      boostExpiry: data.BoostResponse?.BoostExpiry,
    };
    return d;
  }

  static mappingUserRemainingInvitesCredit(data: any): IInviteCredit {
    return {
      dailyLimit: data.DailyLimit,
      remainingCredits: data.RemainingCredits,
      remainingLimit: data.RemainingLimit,
    };
  }
}
